module.exports = __webpack_public_path__ + "img/securities-3.4ed24ae5.jpg";